import { memo } from "react";
import { styled } from "@mui/material/styles";
import SoftTypography from "components/SoftTypography";
import Divider from "@mui/material/Divider";

const FotterWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: "20px"
}));

const ExecutionReportFooter = ({ totalDuration, totalNode }) => {
  return (
    <FotterWrapper>
      <Divider />
      {totalDuration > 0.0 && (
        <SoftTypography variant="button" fontWeight="regular" color="text">
          Total Duration of Execution: {totalDuration} secs
        </SoftTypography>
      )}
      <SoftTypography variant="button" fontWeight="regular" color="text">
        Number of Nodes Executed: {totalNode}
      </SoftTypography>
      <Divider />
    </FotterWrapper>
  );
};

export default memo(ExecutionReportFooter);
